export const GET_COMPANY_INFO = 'companies-modal/GET_COMPANY_INFO';
export const getCompanyInfoAction = id => ({
	type: GET_COMPANY_INFO,
	id,
});

export const SET_COMPANY_INFO = 'companies-modal/SET_COMPANY_INFO';
export const setCompanyInfoAction = payload => ({
	type: SET_COMPANY_INFO,
	payload,
});

export const GET_COMPANY_ABOUT_INFO = 'companies-modal/GET_COMPANY_ABOUT_INFO';
export const getCompanyAboutInfoAction = payload => ({
	type: GET_COMPANY_ABOUT_INFO,
	payload,
});

export const GET_OPTIONS_TYPES = 'companies-modal/GET_OPTIONS_TYPES';
export const getCompanyOptionsAction = () => ({
	type: GET_OPTIONS_TYPES,
});

export const SET_IS_COMPANY_INFO_LOADING = 'companies-modal/SET_IS_COMPANY_INFO_LOADING';
export const setIsCompanyInfoLoadingAction = payload => ({
	type: SET_IS_COMPANY_INFO_LOADING,
	payload,
});

export const UPDATE_COMPANY = 'companies-modal/UPDATE_COMPANY';
export const updateCompanyAction = payload => ({
	type: UPDATE_COMPANY,
	payload,
});

export const SET_IS_COMPANY_SAVING = 'companies-modal/SET_IS_COMPANY_SAVING';
export const setIsCompanySavingAction = payload => ({
	type: SET_IS_COMPANY_SAVING,
	payload,
});

export const RESET_STATE = 'companies-modal/RESET_STATE';
export const resetStateAction = () => ({
	type: RESET_STATE,
});

export const GET_COMPANIES_TYPES = 'companies-modal/GET_COMPANIES_TYPES';
export const getCompaniesTypesAction = () => ({
	type: GET_COMPANIES_TYPES,
});

export const SET_COMPANIES_TYPES = 'companies-modal/SET_COMPANIES_TYPES';
export const setCompaniesTypesAction = payload => ({
	type: SET_COMPANIES_TYPES,
	payload,
});
export const SET_IS_COMPANIES_TYPES_LOADING = 'companies-modal/SET_IS_COMPANIES_TYPES_LOADING';
export const setIsCompaniesTypesLoading = payload => ({
	type: SET_IS_COMPANIES_TYPES_LOADING,
	payload,
});

export const GET_COMPANIES = 'companies-modal/GET_COMPANIES';
export const getCompaniesAction = payload => ({
	type: GET_COMPANIES,
	payload,
});

export const SET_COMPANIES_SEARCH_VALUE = 'companies-modal/SET_COMPANIES_SEARCH_VALUE';
export const setCompaniesSearchValueAction = payload => ({
	type: SET_COMPANIES_SEARCH_VALUE,
	payload,
});

export const SET_COMPANIES = 'companies-modal/SET_COMPANIES';
export const setCompaniesAction = payload => ({
	type: SET_COMPANIES,
	payload,
});

export const SET_COMPANIES_ABOUT = 'companies-modal/SET_COMPANIES_ABOUT';
export const setCompaniesAboutAction = payload => ({
	type: SET_COMPANIES_ABOUT,
	payload,
});

export const SET_IS_COMPANIES_LOADING = 'companies-modal/SET_IS_COMPANIES_LOADING';
export const setIsCompaniesLoadingAction = payload => ({
	type: SET_IS_COMPANIES_LOADING,
	payload,
});

export const SET_IS_COMPANIES_PATCH_LOADING = 'companies-modal/SET_IS_COMPANIES_PATCH_LOADING';
export const setIsCompaniesPatchLoadingAction = payload => ({
	type: SET_IS_COMPANIES_PATCH_LOADING,
	payload,
});

export const GET_ORG_TYPES = 'companies-modal/GET_ORG_TYPES';
export const getOrgTypesAction = () => ({
	type: GET_ORG_TYPES,
});

export const SET_ORG_TYPES = 'companies-modal/SET_ORG_TYPES';
export const setOrgTypesAction = payload => ({
	type: SET_ORG_TYPES,
	payload,
});
export const SET_IS_ORG_TYPES_LOADING = 'companies-modal/SET_IS_ORG_TYPES_LOADING';
export const setIsOrgTypesLoading = payload => ({
	type: SET_IS_ORG_TYPES_LOADING,
	payload,
});

export const SET_IS_CAR_TYPES_LOADING = 'companies-modal/SET_IS_CAR_TYPES_LOADING';
export const setIsCarTypesLoading = payload => ({
	type: SET_IS_CAR_TYPES_LOADING,
	payload,
});
export const SET_IS_MODES_TYPES_LOADING = 'companies-modal/SET_IS_MODES_TYPES_LOADING';
export const setIsModesTypesLoading = payload => ({
	type: SET_IS_MODES_TYPES_LOADING,
	payload,
});
export const SET_IS_TONNAGES_TYPES_LOADING = 'companies-modal/SET_IS_TONNAGES_TYPES_LOADING';
export const setIsTonnagesTypesLoading = payload => ({
	type: SET_IS_TONNAGES_TYPES_LOADING,
	payload,
});
export const SET_IS_DELIVERY_TYPES_LOADING = 'companies-modal/SET_IS_DELIVERY_TYPES_LOADING';
export const setIsDeliveryTypesLoading = payload => ({
	type: SET_IS_DELIVERY_TYPES_LOADING,
	payload,
});

export const GET_TAX_SYSTEMS = 'companies-modal/GET_TAX_SYSTEMS';
export const getTaxSystemsAction = () => ({
	type: GET_TAX_SYSTEMS,
});

export const SET_TAX_SYSTEMS = 'companies-modal/SET_TAX_SYSTEMS';
export const setTaxSystemsAction = payload => ({
	type: SET_TAX_SYSTEMS,
	payload,
});
export const SET_IS_TAX_SYSTEMS_LOADING = 'companies-modal/SET_IS_TAX_SYSTEMS_LOADING';
export const setIsTaxSystemsLoading = payload => ({
	type: SET_IS_TAX_SYSTEMS_LOADING,
	payload,
});

export const GET_TAX_RATES = 'companies-modal/GET_TAX_RATES';
export const getTaxRatesAction = payload => ({
	type: GET_TAX_RATES,
	payload,
});

export const SET_TAX_RATES = 'companies-modal/SET_TAX_RATES';
export const setTaxRatesAction = payload => ({
	type: SET_TAX_RATES,
	payload,
});
export const SET_IS_TAX_RATES_LOADING = 'companies-modal/SET_IS_TAX_RATES_LOADING';
export const setIsTaxRatesLoading = payload => ({
	type: SET_IS_TAX_RATES_LOADING,
	payload,
});
export const GET_COMPANY_SETTINGS = 'companies-modal/GET_COMPANY_SETTINGS';
export const getCompanySettingsAction = payload => ({
	type: GET_COMPANY_SETTINGS,
	payload,
});

export const GET_MODES_TYPES = 'companies-modal/GET_MODES_TYPES';
export const getCompanyModesAction = payload => ({
	type: GET_MODES_TYPES,
	payload,
});
export const GET_TONNAGES_TYPES = 'companies-modal/GET_TONNAGES_TYPES';
export const getCompanyTonnagesAction = payload => ({
	type: GET_TONNAGES_TYPES,
	payload,
});
export const GET_CAR_TYPES = 'companies-modal/GET_CAR_TYPES';
export const getCompanyCarAction = payload => ({
	type: GET_CAR_TYPES,
	payload,
});
export const GET_DELIVERY_TYPES = 'companies-modal/GET_DELIVERY_TYPES';
export const getCompanyDeliveryAction = payload => ({
	type: GET_DELIVERY_TYPES,
	payload,
});
export const UPDATE_COMPANY_SETTINGS = 'companies-modal/UPDATE_COMPANY_SETTINGS';
export const updateCompanySettingsAction = payload => ({
	type: UPDATE_COMPANY_SETTINGS,
	payload,
});
export const SET_COMPANY_SETTINGS = 'companies-modal/SET_COMPANY_SETTINGS';
export const setCompanySettingsAction = payload => ({
	type: SET_COMPANY_SETTINGS,
	payload,
});
export const SET_IS_COMPANY_SETTINGS_LOADING = 'companies-modal/SET_IS_COMPANY_SETTINGS_LOADING';
export const setIsCompanySettingsLoadingAction = payload => ({
	type: SET_IS_COMPANY_SETTINGS_LOADING,
	payload,
});
export const SET_IS_COMPANY_SETTINGS_SAVING = 'companies-modal/SET_IS_COMPANY_SETTINGS_SAVING';
export const setIsCompanySettingsSavingAction = payload => ({
	type: SET_IS_COMPANY_SETTINGS_SAVING,
	payload,
});

export const GET_COMPANY_ADMIN_SETTINGS = 'companies-modal/GET_COMPANY_ADMIN_SETTINGS';
export const getCompanyAdminSettingsAction = payload => ({
	type: GET_COMPANY_ADMIN_SETTINGS,
	payload,
});
export const UPDATE_COMPANY_ADMIN_SETTINGS = 'companies-modal/UPDATE_COMPANY_ADMIN_SETTINGS';
export const updateCompanyAdminSettingsAction = payload => ({
	type: UPDATE_COMPANY_ADMIN_SETTINGS,
	payload,
});
export const CREATE_COMPANY_ABOUT_INFO = 'companies-modal/CREATE_COMPANY_ABOUT_INFO';
export const createCompanyAboutInfo = payload => ({
	type: CREATE_COMPANY_ABOUT_INFO,
	payload,
});

export const SET_COMPANY_ADMIN_SETTINGS = 'companies-modal/SET_COMPANY_ADMIN_SETTINGS';
export const setCompanyAdminSettingsAction = payload => ({
	type: SET_COMPANY_ADMIN_SETTINGS,
	payload,
});
export const SET_IS_COMPANY_ADMIN_SETTINGS_LOADING = 'companies-modal/SET_IS_COMPANY_ADMIN_SETTINGS_LOADING';
export const setIsCompanyAdminSettingsLoadingAction = payload => ({
	type: SET_IS_COMPANY_ADMIN_SETTINGS_LOADING,
	payload,
});

export const SET_IS_COMPANY_ABOUT_LOADING = 'companies-modal/SET_IS_COMPANY_ABOUT_LOADING';
export const setIsCompanyAboutLoadingAction = payload => ({
	type: SET_IS_COMPANY_ABOUT_LOADING,
	payload,
});

export const SET_IS_COMPANY_ADMIN_SETTINGS_SAVING = 'companies-modal/SET_IS_COMPANY_ADMIN_SETTINGS_SAVING';
export const setIsCompanyAdminSettingsSavingAction = payload => ({
	type: SET_IS_COMPANY_ADMIN_SETTINGS_SAVING,
	payload,
});

export const GET_STAGES = 'companies-modal/GET_STAGES';
export const getStagesAction = payload => ({
	type: GET_STAGES,
	payload,
});

export const SET_STAGES = 'companies-modal/SET_STAGES';
export const setStagesAction = payload => ({
	type: SET_STAGES,
	payload,
});

export const SET_IS_STAGES_LOADING = 'companies-modal/SET_IS_STAGES_LOADING';
export const setIsStagesLoadingAction = payload => ({
	type: SET_IS_STAGES_LOADING,
	payload,
});

export const GET_DOCUMENTS_TYPES = 'companies-modal/GET_DOCUMENTS_TYPES';
export const getDocumentsTypesAction = payload => ({
	type: GET_DOCUMENTS_TYPES,
	payload,
});
export const SET_DOCUMENTS_TYPES = 'companies-modal/SET_DOCUMENTS_TYPES';
export const setDocumentsTypesAction = payload => ({
	type: SET_DOCUMENTS_TYPES,
	payload,
});
export const SET_IS_DOCUMENTS_TYPES_LOADING = 'companies-modal/SET_IS_DOCUMENTS_TYPES_LOADING';
export const setIsDocumentsTypesLoadingAction = payload => ({
	type: SET_IS_DOCUMENTS_TYPES_LOADING,
	payload,
});
